<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">推荐给好友</h1>
    </nav>
    <div class="content">
      <div class="content-block-title top">方式一：</div>
      <div class="list-block media-list bottom">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-subtitle">点击右上角，发送给指定好友进行推荐分享！</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block-title top">方式二：</div>
      <div class="list-block media-list bottom">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div style="text-align: center">
                  <img :src=resource>
                </div>
                <div class="item-subtitle" style="text-align: center">
                  <p>长按二维码，选择发送给朋友，即可进行推荐分享！</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    created () {},
    mounted () {},
    data () {
      return {
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      resource () {
        let customerNo = this.sessionInfo.customerInfo.customerNo
        let src = 'wxQr/' + customerNo + '.jpg?introducer=' + customerNo + ''
        return src
      }
    },
    methods: {}
  }
</script>

<style scoped>
  .top {
    margin-top: 0.5rem;
  }
  .bottom {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// MyRecommend.vue?3f31a19c